import type { DemoSlot } from './demoTypes';

const SLOTS_KEY = 'sigma-demo-slots';
const ACTIVE_SLOT_KEY = 'sigma-demo-active-slot';

function generateUserId(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.floor(Date.now() * Math.random()) + Math.floor(Math.random() * 16)) % 16;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

const DEFAULT_SLOTS: DemoSlot[] = [
  { userId: generateUserId(), nombre: 'Usuario 1', correo: 'user1@sigma.demo', ouId: '', tenant: 'LATAM' },
  { userId: generateUserId(), nombre: 'Usuario 2', correo: 'user2@sigma.demo', ouId: '', tenant: 'LATAM' },
  { userId: generateUserId(), nombre: 'Usuario 3', correo: 'user3@sigma.demo', ouId: '', tenant: 'LATAM' },
  { userId: generateUserId(), nombre: 'Usuario 4', correo: 'user4@sigma.demo', ouId: '', tenant: 'LATAM' },
];

export function loadSlots(): DemoSlot[] {
  try {
    const raw = localStorage.getItem(SLOTS_KEY);
    if (!raw) return initSlots();
    const parsed = JSON.parse(raw) as unknown[];
    if (!Array.isArray(parsed) || parsed.length !== 4) return initSlots();
    return parsed.map((s, i) => sanitizeSlot(s, i));
  } catch {
    return initSlots();
  }
}

function initSlots(): DemoSlot[] {
  const slots = DEFAULT_SLOTS.map(s => ({ ...s, userId: generateUserId() }));
  saveSlots(slots);
  return slots;
}

function sanitizeSlot(raw: unknown, index: number): DemoSlot {
  const s = (typeof raw === 'object' && raw !== null ? raw : {}) as Record<string, unknown>;
  return {
    userId:  typeof s['userId'] === 'string' && s['userId'] ? s['userId'] : generateUserId(),
    nombre:  typeof s['nombre'] === 'string' ? s['nombre'] : `Usuario ${index + 1}`,
    correo:  typeof s['correo'] === 'string' ? s['correo'] : `user${index + 1}@sigma.demo`,
    ouId:    typeof s['ouId'] === 'string' ? s['ouId'] : '',
    tenant:  s['tenant'] === 'Europa' ? 'Europa' : 'LATAM',
  };
}

export function saveSlots(slots: DemoSlot[]): void {
  try { localStorage.setItem(SLOTS_KEY, JSON.stringify(slots)); } catch { /* noop */ }
}

export function loadActiveSlotIndex(): number {
  try {
    const raw = localStorage.getItem(ACTIVE_SLOT_KEY);
    const n = raw ? parseInt(raw, 10) : 0;
    return isNaN(n) || n < 0 || n > 3 ? 0 : n;
  } catch {
    return 0;
  }
}

export function saveActiveSlotIndex(index: number): void {
  try { localStorage.setItem(ACTIVE_SLOT_KEY, String(index)); } catch { /* noop */ }
}
